export default class Sesame {
  passwordLength = 16;

  minLowercase = 1;
  minUppercase = 1;
  minNumbers = 1;
  minSpecial = 1;

  lowercaseList = "abcdefghijklmnopqrstuvwxyz";
  uppercaseList = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  numbersList = "0123456789";
  specialList = "_,.:/=+-&#()!?@";

  constructor(passwordLength = 16) {
    this.passwordLength = passwordLength;
  }

  generate() {
    let password = this.createRequiredChars(this.specialList, this.minSpecial);

    if (password.length <= this.passwordLength) {
      password += this.createRequiredChars(this.numbersList, this.minNumbers);
      password += this.createRequiredChars(this.lowercaseList, this.minLowercase);
      password += this.createRequiredChars(this.uppercaseList, this.minUppercase);
      password += this.createRequiredChars(this.specialList, this.minSpecial);
      password += this.createFillingCharacters(password);
    }

    return this.shuffleString(password);
  }

  /**
   * @description Generates a string based on the full character set.
   *
   * @param   {string}        password:       The currently generated password
   *
   * @returns {number}    Returns a string long enough to fill the password, empty string if the password is long enough
   */
  createFillingCharacters(password) {
    return this.createRequiredChars(this.getTotalCharList(), this.getRemainingCharactersCount(password));
  }

  /**
   * @description The number of characters that are left to be generated.
   *
   * @param   {string}        password:       The currently generated password
   *
   * @returns {number}    Returns a none-negative number
   */
  getRemainingCharactersCount(password) {
    const remaining = this.passwordLength - password.length;
    return remaining >= 0 ? remaining : 0;
  }

  /**
   * @description Generate a random string based on the character list and count
   *
   * @param   {string}        charList:       The character list
   * @param   {number}        count:          Number of characters, 0 will return an empty string
   *
   * @returns {string}    Randomly generated string of characters
   */
  createRequiredChars(charList, count) {
    let ret = "";

    if (count <= 0) {
      return ret;
    }

    for (let i = 0, n = charList.length; i < count; ++i) {
      ret += charList.charAt(Math.floor(Math.random() * n));
    }

    return ret;
  }

  /**
   * @description Shuffles the characters in the given string around with Fisher-Yates
   *
   * @param   {string}        password:       The currently generated password
   *
   * @returns {string}    Returns a shuffled password
   */
  shuffleString(password) {
    return [...password]
      .reduceRight((res, _, __, arr) => (res.push(...arr.splice(0 | (Math.random() * arr.length), 1)), res), [])
      .join("");
  }

  /**
   * @description Returns the full charlist
   *
   * @returns {string}    Returns the full charlist
   */
  getTotalCharList() {
    return this.lowercaseList + this.uppercaseList + this.numbersList + this.specialList;
  }
}
